'use client';

import {ArticleSelectionCard} from '@shared/Articles/ArticlePage/ArticleSelectionCard/ArticleSelectionCard';
import {SelectionHead} from '@shared/Articles/ArticlesWithSelectionsView/parts/SelectionHead/SelectionHead';
import Image from 'next/image';
import Link from 'next/link';

import Arrow from '@ui-kit/src/assets/Icons/arrow_right_20.svg';

import {articleSelectionType} from '@strapi/types/ArticleMainInfo';

import {useIsTablet} from '@utils/hooks/useIsTablet';

import styles from './TilesWithBlog.module.scss';

type Props = {
  selection: articleSelectionType;
  handleArticleCardClick: (
    compilationName: string,
    article_name: string,
  ) => void;
  basePath: 'blog' | 'prostore';
};
export const TilesWithBlog = ({
  selection,
  handleArticleCardClick,
  basePath,
}: Props) => {
  const isTablet = useIsTablet();
  const {articles, title, allArticlesLink} = selection;

  if (!articles.length) {
    return null;
  }

  return (
    <div className={styles.container}>
      {!isTablet && (
        <>
          <SelectionHead title={title} link={allArticlesLink} />
          <div className={styles.acticles}>
            <div className={styles.tiles}>
              {articles.slice(0, 4).map((elem) => (
                <ArticleSelectionCard
                  key={elem.id}
                  card={elem}
                  articleUrl={basePath}
                  type="secondary"
                  onArticleClick={() =>
                    handleArticleCardClick(title, elem.cardTitle)
                  }
                />
              ))}
            </div>
            <div className={styles.blog}>
              {articles.slice(4, 10).map((elem) => (
                <ArticleSelectionCard
                  key={elem.id}
                  card={elem}
                  articleUrl={basePath}
                  type="blog"
                  onArticleClick={() =>
                    handleArticleCardClick(title, elem.cardTitle)
                  }
                />
              ))}
            </div>
          </div>
        </>
      )}
      {isTablet && (
        <>
          <SelectionHead isLinkShown={false} title={title} />
          <div className={styles.mobileArticles}>
            {articles.slice(0, 9).map((elem) => (
              <ArticleSelectionCard
                key={elem.id}
                card={elem}
                articleUrl={basePath}
                type="blog"
                onArticleClick={() =>
                  handleArticleCardClick(title, elem.cardTitle)
                }
              />
            ))}
          </div>
          {allArticlesLink && (
            <Link href={allArticlesLink?.href} className={styles.link}>
              {allArticlesLink?.title}
              <Image
                src={Arrow}
                alt=""
                width={20}
                height={20}
                className={styles.icon}
              />
            </Link>
          )}
        </>
      )}
    </div>
  );
};
